import { DOCUMENT_TYPES, FOREIGN_DOCUMENT, INTERNATIONAL_DOCUMENT, NATIONAL_DOCUMENT } from 'constants/documentTypes';

export const isInternationalDocument = documentType =>
    documentType === DOCUMENT_TYPES.DOCUMENT_PASSPORT ||
    documentType === DOCUMENT_TYPES.DOCUMENT_PP ||
    documentType === DOCUMENT_TYPES.DOCUMENT_PN ||
    documentType === DOCUMENT_TYPES.DOCUMENT_PA;

export const isNationalDocument = documentType =>
    documentType === DOCUMENT_TYPES.DOCUMENT_DNI ||
    documentType === DOCUMENT_TYPES.DOCUMENT_DA ||
    documentType === DOCUMENT_TYPES.DOCUMENT_CC ||
    documentType === DOCUMENT_TYPES.DOCUMENT_DN;

export const isForeignerDocument = documentType => documentType === DOCUMENT_TYPES.DOCUMENT_NIE;

export const getDocumentTypeAggregation = documentType => {
    if (isInternationalDocument(documentType)) return INTERNATIONAL_DOCUMENT;
    if (isNationalDocument(documentType)) return NATIONAL_DOCUMENT;
    if (isForeignerDocument(documentType)) return FOREIGN_DOCUMENT;
};
